import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PopoverUserPermissionPage } from './popover-user-permission.page';

const routes: Routes = [
  {
    path: '',
    component: PopoverUserPermissionPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PopoverUserPermissionPageRoutingModule {}
